import { withStyles } from '@material-ui/core/styles';

export default withStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: '95vw',
    [theme.breakpoints.up('md')]: {
      width: 650,
    },
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
  },
  textField: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    width: 200,
  },
  button: {
    background: '#009358',
    color: '#FFFFFF',
  },
  button2: {
    background: '#586375',
    color: '#FFFFFF',
  },
  checkbox: {
    width: 20,
    height: 20,
    position: 'relative',
    top: -2,
  },
  inputAmount: {
    width: '100%',
    margin: 0,
  },
  contentAmount: {
    width: '100%',
    borderBottom: '1px solid #ddd',
    padding: '0.5rem 1rem',
    [theme.breakpoints.down('sm')]: {
      padding: '16px 8px 24px 8px',
      textAlign: 'right',
    },
  },
  rowAmount: {
    width: '100%',
    fontSize: '1rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
    '& .amount__checkbox': {
      display: 'flex',
      alignItems: 'center',
      minWidth: 200,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
      '& span.label': {
        fontSize: '1rem',
        lineHeight: '1rem',
        fontWeight: 400,
        textAlign: 'left',
        '&:first-child': {
          [theme.breakpoints.down('sm')]: {
            marginLeft: '0 !important',
            marginTop: '0 !important',
            marginBottom: '8px !important',
            display: 'block',
            width: '100%',
          },
        },
      },
    },
    '& .amount__value': {
      display: 'flex',
      alignItems: 'center',
      minWidth: 150,
      fontSize: '1rem',
      fontWeight: 400,
      whiteSpace: 'nowrap',
      position: 'relative',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    '& .amount__input': {
      width: 140,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginTop: 8,
      },
    },
  },
  transfer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #ddd',
    padding: '0.85rem 26px',
    marginBottom: '1rem',
    [theme.breakpoints.down('sm')]: {
      padding: '16px 8px',
    },
    '& h3, span': {
      fontWeight: 400,
      color: '#222',
      fontSize: 18,
      lineHeight: '18px',
      margin: 0,
    },
    '& h3': {
      [theme.breakpoints.down('sm')]: {
        margin: 0,
        fontSize: 15,
      },
    },
  },
  table: {
    background: '#fff',
    border: '1px solid #eee',
    padding: '0.5rem 1rem 1rem',
    borderRadius: 5,
    marginTop: 10,
    width: '100%',
    maxHeight: 230,
    overflowY: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginTop: 24,
    },
  },
  bank: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontSize: 15,
    '& span': {
      fontWeight: 400,
      [theme.breakpoints.down('sm')]: {
        fontWeight: 600,
      },
    },
  },
  anticipation: {
    width: '100%',
    '& .anticipation__switch': {
      width: '100%',
      fontWeight: 400,
      fontSize: 15,
      [theme.breakpoints.down('sm')]: {
        fontSize: 13,
      },
    },
    '& .anticipation__select-day': {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'row',
      fontSize: 12,
      fontWeight: 400,
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
      },
    },
    '& .anticipation__radio': {
      display: 'block',
      height: 26,
      marginTop: 4,
    },
    '& p': {
      fontSize: 12,
      lineHeight: '18px',
      color: '#383838',
    },
  },
}));
